import { qpDatatables, qpOpenModal } from "../utils/misc";
import { push } from 'react-router-redux';
import { toast } from "react-toastify";
const deliveryOrderConstants = {
    DO_GETALL_REQUEST: 'DO_GETALL_REQUEST',
    DO_GETALL_RESPONSE: 'DO_GETALL_RESPONSE',
    DOC_GET_REQUEST: 'DOC_GET_REQUEST',
    DOC_GET_RESPONSE:'DOC_GET_RESPONSE',
};

const initialState = { doItems: [], isLoading: false, docIt:[], orderNumber:'' };

export const actionCreators = {
    getShipments: (Filtertype) => async (dispatch, getState) => {
        var pagetype = Filtertype != null ? Filtertype:"Open";
         const url = `api/Shipment/GetShipments?pagetype=` + pagetype;
             dispatch({ type: deliveryOrderConstants.DO_GETALL_REQUEST })
             fetch(url, {
                 method: 'get',
                 headers: {
                     'Accept': 'application/json',
                     'Content-Type': 'application/json',
                     'Authorization': 'Bearer ' + getState().account.user.token
                 }
             })
                 .then(handleResponse)
                 .then(
                     result => {
                         dispatch({ type: deliveryOrderConstants.DO_GETALL_RESPONSE, doItems: result });
                         qpDatatables();
                     },
                     error => {
                         if (error.status === 401) {
                             dispatch(push('/login'));
                         } else {
                             toast.warn("Error:"+error.error, {
                                 position: toast.POSITION.BOTTOM_RIGHT,
                             });
                         }
                    }
                 );
    },
    getDocuments: (number,orderNumber) => async (dispatch, getState) => {
        console.log("test2", number)
        const url = 'api/Shipment/GetDocuments/' + number;
        dispatch({ type: deliveryOrderConstants.DOC_GET_REQUEST })
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
        })
            .then(handleResponse)
            .then(
                result => {
                    dispatch({ type: deliveryOrderConstants.DOC_GET_RESPONSE, docIt: result, orderNumber })
                    qpOpenModal('#shipmentModal');
                },
                error => {
                    if (error.status === 401) {
                        dispatch(push('/login'));
                    } else {
                        toast.warn("Error:" + error.error, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                });
    }
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status===401) {
                return Promise.reject({status: response.status});
            }
            const error = text;
            return Promise.reject({ status:response.status, error});
        }
        return data;
    });
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === deliveryOrderConstants.DO_GETALL_REQUEST) {
        return {
            ...state,
            isLoading: true,
        };
    }

    if (action.type === deliveryOrderConstants.DO_GETALL_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            doItems: action.doItems
        };
    }
    if (action.type === deliveryOrderConstants.DOC_GET_REQUEST) {
        return {
            ...state,
            docIt: []
        };
    }
    if (action.type === deliveryOrderConstants.DOC_GET_RESPONSE) {
        return {
            ...state,
            docIt: action.docIt,
            orderNumber: action.orderNumber
        };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/ShipmentStore.js